import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/system";

export const ShimmerSkeleton = styled(Box)(({ theme }) => ({
  height: "20px",
  width: "100%",
  borderRadius: "4px",
  background: `linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%)`,
  backgroundSize: "200px 100%",
  animation: "shimmer 1.5s infinite",
  "@keyframes shimmer": {
    "0%": {
      backgroundPosition: "-200px 0",
    },
    "100%": {
      backgroundPosition: "200px 0",
    },
  },
}));

const MuiSkeletonLoader = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, width:"100%" }}>
      <ShimmerSkeleton />
      <ShimmerSkeleton sx={{ width: "100%", height: "40px" }} />
      <ShimmerSkeleton sx={{ width: "100%" }} />
    </Box>
  );
};

export default MuiSkeletonLoader;
